import PropTypes from 'prop-types';

const TreeNavigatorActionsPropTypes = {
  onNewTemplateClick:PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default TreeNavigatorActionsPropTypes;
